var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcOwner = function SvgIcOwner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4542 5.6118L11.484 8.71628L9.04823 4.14315C8.5945 3.29538 7.38853 3.29538 6.9348 4.14315L4.52285 8.71628L2.54077 5.6118C1.89599 4.59688 0.34375 5.05061 0.34375 6.25658V11.1879V12.1551H15.6632V11.176V6.25658C15.6512 5.05061 14.099 4.59688 13.4542 5.6118Z",
    fill: "#FFBF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00005 2.54328C8.70452 2.54328 9.27766 1.97015 9.27766 1.26567C9.27766 0.573134 8.70452 0 8.00005 0C7.29557 0 6.73438 0.573134 6.73438 1.27761C6.73438 1.97015 7.29557 2.54328 8.00005 2.54328Z",
    fill: "#FFBF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9837 2.125C14.4225 2.125 13.9688 2.57873 13.9688 3.13993C13.9688 3.70112 14.4225 4.15485 14.9837 4.15485C15.5449 4.15485 15.9986 3.70112 15.9986 3.13993C15.9986 2.57873 15.5449 2.125 14.9837 2.125Z",
    fill: "#FFBF00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.02985 3.13993C2.02985 2.57873 1.57612 2.125 1.01493 2.125C0.453731 2.125 0 2.57873 0 3.13993C0 3.70112 0.453731 4.15485 1.01493 4.15485C1.57612 4.15485 2.02985 3.70112 2.02985 3.13993Z",
    fill: "#FFBF00"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcOwner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "public/media/ic_owner.98c9d130.svg";
export { ForwardRef as ReactComponent };